import moment from 'moment-timezone'
import { formatPhone, isPhoneComplete } from '@/utils/phoneMask'

export function formatPhoneDisplay(value) {
  const raw = String(value ?? '').trim()
  if (!raw) return ''

  // Форматируем полные номера поддерживаемых стран: +7 / +976 / +998
  return isPhoneComplete(raw) ? formatPhone(raw) : raw
}

export function formatCallDuration(seconds) {
  const total = Math.max(0, Number(seconds) || 0)
  const minutes = Math.floor(total / 60)

  const rest = total % 60

  return `${String(minutes).padStart(2, '0')}:${String(rest).padStart(2, '0')}`
}

export function formatCallDateTime(value) {
  if (!value) return ''

  const date = new Date(value)

  if (Number.isNaN(date.getTime())) return String(value)
  return new Intl.DateTimeFormat('ru-RU', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date)
}

export function getDayRangeIso(timezone, now = moment()) {
  const day = moment.tz(now, timezone)

  return {
    from: day.clone().startOf('day').toISOString(),
    to: day.clone().add(1, 'day').startOf('day').toISOString(),
  }
}
